import React from 'react';
import Select from 'components/Select';
import { AGENDA_RANGE } from 'enums';
import IncludeHeadersOption from './IncludeHeadersOption';

const RANGE_OPTIONS = [
	{ id: AGENDA_RANGE.FULL, name: 'Full agenda' },
	{ id: AGENDA_RANGE.TODAY, name: 'Today only' },
];

const AgendaWidgetOptions = props => {
	const { widgetProps, handlePropChange } = props;

	return (
		<IncludeHeadersOption {...props}>
			<h4 className="admin-form-item-label">Show</h4>
			<Select
				data={RANGE_OPTIONS}
				value={[widgetProps.range ?? AGENDA_RANGE.FULL]}
				onChange={handlePropChange('range')}
				form={true}
			/>
		</IncludeHeadersOption>
	);
};

export default AgendaWidgetOptions;
